<template>
  <div class="collect-vip">
    <div
      v-if="surveyData.status==='published'"
      class="vip_wrap"
    >
      <order
        v-if="surveyData.orders"
        :survey="surveyData"
      ></order>
      <template v-else>
        <div class="v_title">加速服务</div>
        <div class="v_describe">由月兔帮您快速收集有效问卷</div>
        <el-card class="v_box-card">
          <el-form
            ref="vipform"
            label-width="80px"
            :model="form"
            size="medium"
            :rules="rules"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <div class="form_title">
                  <img src="@/assets/images/survey/collect/xuhao_1.svg" />
                  筛选人群
                </div>
                <el-form-item
                  label="年龄"
                  prop="tags.age"
                >
                  <el-row>
                    <el-col :span="10">
                      <el-input v-model.number.trim="form.tags.age[0]"></el-input>
                    </el-col>
                    <el-col :span="4">
                      ——
                    </el-col>
                    <el-col :span="10">
                      <el-input v-model.number.trim="form.tags.age[1]"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select
                        v-model="form.tags.sex"
                        placeholder=""
                      >
                        <el-option
                          label="不限"
                          value=""
                        ></el-option>
                        <el-option
                          label="男"
                          value="男"
                        ></el-option>
                        <el-option
                          label="女"
                          value="女"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="学历">
                      <el-select
                        v-model="form.tags.education"
                        placeholder=""
                      >
                        <el-option
                          label="不限"
                          value=""
                        ></el-option>
                        <el-option
                          label="博士"
                          value="博士"
                        ></el-option>
                        <el-option
                          label="硕士"
                          value="硕士"
                        ></el-option>
                        <el-option
                          label="本科"
                          value="本科"
                        ></el-option>
                        <el-option
                          label="专科"
                          value="专科"
                        ></el-option>
                        <el-option
                          label="高中"
                          value="高中"
                        ></el-option>
                        <el-option
                          label="初中"
                          value="初中"
                        ></el-option>
                        <el-option
                          label="小学"
                          value="小学"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="婚恋状态">
                  <el-select
                    v-model="form.tags.marriage"
                    placeholder=""
                  >
                    <el-option
                      label="不限"
                      value=""
                    ></el-option>
                    <el-option
                      label="单身"
                      value="单身"
                    ></el-option>
                    <el-option
                      label="新婚"
                      value="新婚"
                    ></el-option>
                    <el-option
                      label="已婚"
                      value="已婚"
                    ></el-option>
                    <el-option
                      label="育儿"
                      value="育儿"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地理位置">
                  <el-input v-model="form.tags.position"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div class="form_title">
                  <img src="@/assets/images/survey/collect/xuhao_2.svg" />
                  回收设置
                </div>
                <el-form-item
                  label="回收数量"
                  prop="quantity"
                >
                  <el-input v-model="form.quantity"></el-input>
                </el-form-item>
                <el-form-item
                  label="预计时间"
                  prop="estimated_time"
                >
                  <el-date-picker
                    v-model="form.estimated_time"
                    type="date"
                    placeholder=""
                    :editable="false"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label="联系方式"
                  prop="contact"
                >
                  <el-input v-model="form.contact"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input v-model="form.comment"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="v_btn">
            <el-button
              type="primary"
              @click="submit"
            >确定申请</el-button>
          </div>
        </el-card>
        <div class="v_foot">
          <div class="f_label">
            <img
              src="@/assets/images/survey/collect/iphone.svg"
              height="20"
            />
            联系方式：400-006-2028
          </div>
          <div class="f_label">
            <img
              src="@/assets/images/survey/collect/time.svg"
              height="20"
            />
            周一 - 周六，08:30 - 17:30
          </div>
        </div>
      </template>
    </div>
    <no-release
      v-else
      :data="surveyData"
    ></no-release>
  </div>
</template>

<script>
import NoRelease from "./components/no-release";
import Order from "./components/order";
import { vipService } from "@/api/survey";
export default {
  inject: ["reload"],
  data() {
    var checkAge = (rule, value, callback) => {
      //年龄无限制
      if (value.join("") === "") {
        callback();
        return;
      }
      const min = value[0];
      const max = value[1];
      if (min !== "" && max !== "" && max < min) {
        // 最大年龄小于最小年龄
        callback(new Error("请输入有效的年龄区间"));
        return;
      }
      //最小年龄不能低于14岁，最大年龄不能高于60岁
      if (min < 14 || max > 60) {
        callback(new Error("有效年龄为 14 - 60 岁"));
        return;
      }
    };
    return {
      form: {
        survey_id: "",
        quantity: "",
        estimated_time: "",
        contact: "",
        comment: "",
        tags: {
          age: ["", ""],
          sex: "",
          position: "",
          education: "",
          marriage: ""
        }
      },
      rules: {
        "tags.age": [
          {
            validator: checkAge,
            trigger: "blur"
          }
        ],
        quantity: [
          {
            required: true,
            message: "回收数量不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]+$/,
            message: "请输入有效数字",
            trigger: "blur"
          }
        ],
        estimated_time: [
          {
            required: true,
            message: "请选择预计时间",
            trigger: "change"
          }
        ],
        contact: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            pattern: /^((\+|00)86)?1([358][0-9]|4[579]|6[67]|7[0135678]|9[189])[0-9]{8}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    surveyData() {
      return this.$store.state.survey.surveyBody;
    }
  },
  methods: {
    submit() {
      this.$refs["vipform"].validate(v => {
        if (v) {
          this.$set(this.form, "survey_id", this.id);
          vipService(this.form).then(() => {
            this.reload();
          });
        }
      });
    }
  },
  components: {
    NoRelease,
    Order
  }
};
</script>

<style lang="less" scoped>
.collect-vip {
  padding-top: 40px;
}

.vip_wrap {
  width: 900px;
  margin: 0 auto;
  text-align: center;
}

.v_title {
  font-size: 30px;
  color: #1d82fc;
}

.v_describe {
  font-size: 18px;
  margin: 10px 0 30px;
}

.v_box-card {
  .el-card__body {
    padding: 40px 30px 20px;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 100%;
  }
}

.form_title {
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 40px;

  img {
    height: 18px;
    vertical-align: text-bottom;
  }
}

.v_btn {
  text-align: right;
}

.v_foot {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;

  .f_label {
    font-size: 24px;
  }
}
</style>
